import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface CoolnetPageLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  showContact?: boolean;
}

export default function CoolnetPageLayout({
  title,
  subtitle,
  children,
  showContact = true,
}: CoolnetPageLayoutProps) {
  const { t } = useTranslation("home");

  return (
    <div className="w-full">
      {/* Page Hero */}
      <section className="relative w-full bg-magenta py-12 md:py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
              backgroundRepeat: "repeat",
            }}
          />
        </div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <div className="mb-3">
            <Link
              to="/coolnet"
              className="inline-flex items-center gap-2 text-white/80 text-sm hover:text-white transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </span>
              {t("coolnetPage.back")}
            </Link>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 uppercase tracking-wide">
            {title}
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto">
            {subtitle}
          </p>
          <div className="w-20 h-1 bg-white/50 mx-auto mt-6" />
        </div>
      </section>

      {/* Content */}
      <div className="w-full px-4 md:px-6 py-12 md:py-20">
        {children}
      </div>

      {/* Contact CTA */}
      {showContact && (
        <section className="w-full bg-brandgreen py-10 md:py-14">
          <div className="w-full px-4 md:px-6 text-center">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 uppercase tracking-wide">
              {t("coolnetPage.cta")}
            </h3>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+524772847060"
                className="inline-flex items-center gap-2 bg-white text-brandgreen font-semibold px-6 py-3 rounded-md hover:bg-surface transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </span>
                +52 477 284 70 60
              </a>
              <a
                href="mailto:comercial@ventracore.com.mx"
                className="inline-flex items-center gap-2 bg-white text-brandgreen font-semibold px-6 py-3 rounded-md hover:bg-surface transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line" />
                </span>
                comercial@ventracore.com.mx
              </a>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}